export const mapDayToNumber = (day) => {
  switch (day) {
    case "Sunday":
      return 0;
    case "Monday":
      return 1;
    case "Tuesday":
      return 2;
    case "Wednesday":
      return 3;
    case "Thursday":
      return 4;
    case "Friday":
      return 5;
    case "Saturday":
      return 6;
    default:
      return null;
  }
};

export const mapPmTimeTo24Hour = (time) => {
  switch (time) {
    case "8-11AM":
      return { start: "08:00:00", end: "11:00:00" };
    case "8-12PM":
      return { start: "08:00:00", end: "12:00:00" };
    case "11-2:30PM":
      return { start: "11:00:00", end: "14:30:00" };
    case "2:30-5:30PM":
      return { start: "14:30:00", end: "17:30:00" };
    default:
      return null;
  }
};
